import React from "react"
import { useNavigate } from "react-router-dom";
import ComparisonTable from "./components/ComparisonTable"
import MobileOnlyWarning from './components/MobileOnlyWarning'


function GettingStartedPage({premiumCreditsRemaining})
{
    const navigate = useNavigate();

    const selectPremiumReport = () => { navigate('/uploadXml/premium') }
    const selectPreliminaryReport = () => { navigate('/uploadXml/preliminary') }

    return (
        <>
            <div className="contentsAreaHeader">
                <div className="areaTitle">Lets get started!</div>
                <div className="areaExplainer">Realising the value of Property Professionals with epIMS</div>
            </div>
            <div className="contents">
                <MobileOnlyWarning />
                <p><strong>Welcome to epIMS!</strong></p>
                <p>
                    We want to help you maximise your service by providing energy efficiency reports to go alongside every EPC or EPR you produce.
                    Generating a report is free, simple and only takes seconds.
                </p>
                <p>
                    <strong>Get started</strong> by clicking the &lsquo;Create Report&rsquo; button below.
                </p>
                <ComparisonTable {...{premiumCreditsRemaining, selectPremiumReport, selectPreliminaryReport}} />
            </div>
        </>
    )
}

export default GettingStartedPage;